// extracted by mini-css-extract-plugin
export default {"table":"style_table__hc04E","tableCellHead":"style_tableCellHead__026NZ","tableCell":"style_tableCell__Eeilt"};